// extracted by mini-css-extract-plugin
module.exports = {"mask":"_2-2kC","box":"Q54jw","view":"_2AcAs","loading":"_2LtL2"};